import { Navigate } from "react-router-dom"
import { useSelector } from "react-redux"
import SohoLoader from "../components/common/SohoLoader/SohoLoader"
import {
  canAccessExecutiveDashboard,
  isOrganizationRolePending,
} from "../lib/utils/userRoleDisplay"

/**
 * Restricts Executive Dashboard to organization Owner and Admin roles.
 */
export default function ExecutiveDashboardGuard({ children }) {
  const userProfile = useSelector((state) => state.user?.profile)
  const { userOrgRole, organizations, organizationsStatus, userOrgRoleStatus } = useSelector(
    (state) => state.organizationRole || {},
  )

  const orgRolePending = isOrganizationRolePending({
    hasUserId: Boolean(userProfile?.id),
    organizationsStatus,
    userOrgRoleStatus,
    organizationCount: organizations?.length ?? 0,
  })

  if (orgRolePending) {
    return <SohoLoader size="lg" fullScreen />
  }

  if (!canAccessExecutiveDashboard(userOrgRole?.role)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}
